import { APP } from 'src/Configs/App'
import { currencySymbolConverter } from 'src/Constants/functions'
import { rtkApi } from 'src/Services/rtkApi'

interface GetCurrencyInfoResponse {
  currencyName: string
  currencyRate: number
}

export interface TransformedCurrencyInfo {
  currencySymbol: string
  currencyRate: number
}

const currencyApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrencyInfo: builder.query<TransformedCurrencyInfo, void | null>({
      query: () => `${APP.TIKTOK_SERVER}/artist/currencies/exchange-rate`,
      transformResponse: (response: GetCurrencyInfoResponse) => ({
        currencySymbol:
          response.currencyRate > 0
            ? currencySymbolConverter(response.currencyName)
            : '$',
        currencyRate: response.currencyRate > 0 ? response.currencyRate : 1,
      }),
    }),
  }),
})

export const { useGetCurrencyInfoQuery } = currencyApi
